import React, { useEffect, useContext } from 'react';
import ReactGA from 'react-ga';

import { LoanApplication, useGetLoanQuery, useSetReasonForLoanMutation } from 'generated/graphql';
import { useNeuroId, useNavigation} from 'hooks/index';
import ReasonLayout from './reason-layout';
import { ProfileContext } from 'providers/profile.provider';
import { registerTagmanagerEvent, TagManagerEvent } from 'configs/trackers';
import { LoanApplicationContext } from 'containers/context/useGetLoanApplication';

const ReasonForLoan: React.FC = () => {
    const [setReasonForLoan] = useSetReasonForLoanMutation();
    const { nextScreen, previousScreen,reset } = useNavigation();
    const {
        steps: { reasonForLoan },
    } = useContext(ProfileContext);

    const { setUserId } = useNeuroId();
    const { loanApplicationId } = useContext(LoanApplicationContext);

    const { data } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"cache-first"
    });

    useEffect(() => {
        if(!loanApplicationId) {
            reset();
        }
        setUserId(loanApplicationId);
    },[loanApplicationId])

    useEffect(() => {
        ReactGA.event({
            category: 'Navegação Direto',
            action: 'Exibição',
            label: 'Exibição /pedido/motivo',
            nonInteraction: true,
        });
    }, []);

    const onSubmit = (loanApplication: LoanApplication) => {
        const { reason, reasonDetail } = loanApplication;

        setReasonForLoan({
            variables: {
                loanApplicationId: data?.loanApplication.id,
                loanApplication: { reason, reasonDetail },
            },
        });

        nextScreen();
        registerTagmanagerEvent(
            TagManagerEvent.INTENTION,
            { intent : reason }
        );
    };

    return (
        <ReasonLayout
            initialValue={data?.loanApplication}
            stepInfo={reasonForLoan}
            onBack={previousScreen}
            onSubmit={onSubmit}
        />
    );
};

export default ReasonForLoan;
